/**
 * [2026-03-23 최종본 고도화]
 * 역량 검사 문항 데이터 (총 60문항)
 * 카테고리: C(공통/기초), A(배우/소통), S(가수/현장) 각 20문항
 * rev: true (역채점 문항 - 점수를 반대로 계산함)
 */

export interface Question {
  id: number;
  text: string;
  category: "C" | "A" | "S";
  rev?: boolean;
}

export const QUESTIONS: Question[] = [
  // --- [공통 역량: C (1-20)] ---
  {
    id: 1,
    text: "나는 처음 가보는 길도 지도 앱을 활용해 능숙하게 운전할 수 있다.",
    category: "C",
  },
  {
    id: 2,
    text: "낯선 사람과 대화할 때 어색함보다는 목적 중심의 대화를 잘 이끌어낸다.",
    category: "C",
  },
  {
    id: 3,
    text: "돌발 상황이 발생하면 당황해서 대처가 늦어지는 편이다.",
    category: "C",
    rev: true,
  },
  {
    id: 4,
    text: "매일 반복되는 행정 업무나 정산 작업도 꼼꼼하게 처리할 수 있다.",
    category: "C",
  },
  {
    id: 5,
    text: "상급자의 지시가 내 생각과 다르더라도 우선 지시에 따르는 편이다.",
    category: "C",
  },
  {
    id: 6,
    text: "나는 약속 시간을 지키는 것을 모든 업무의 기본이라고 생각한다.",
    category: "C",
  },
  {
    id: 7,
    text: "장시간 운전을 하거나 대기하는 환경에서도 집중력을 잘 유지한다.",
    category: "C",
  },
  {
    id: 8,
    text: "업무상 비밀이나 아티스트의 사생활을 철저히 보안 유지할 자신이 있다.",
    category: "C",
  },
  {
    id: 9,
    text: "복잡한 스케줄을 조율할 때 우선순위를 정하는 것이 어렵게 느껴진다.",
    category: "C",
    rev: true,
  },
  {
    id: 10,
    text: "나는 문서 작성 도구(엑셀, 워드 등)를 활용해 보고서를 작성할 수 있다.",
    category: "C",
  },
  {
    id: 11,
    text: "현장 스태프들과의 마찰이 생겼을 때 감정적으로 대응하는 편이다.",
    category: "C",
    rev: true,
  },
  {
    id: 12,
    text: "업무용 차량의 소모품 관리나 청결 상태를 주기적으로 체크한다.",
    category: "C",
  },
  {
    id: 13,
    text: "나는 멀티태스킹(운전 중 통화 조율 등) 상황에서도 평정심을 유지한다.",
    category: "C",
  },
  {
    id: 14,
    text: "엔터테인먼트 산업의 최신 트렌드나 뉴스를 매일 확인한다.",
    category: "C",
  },
  {
    id: 15,
    text: "모르는 실무 지식이 생기면 스스로 찾아보기보다 질문부터 하는 편이다.",
    category: "C",
    rev: true,
  },
  {
    id: 16,
    text: "법규(교통법규 등)를 준수하는 것이 효율성보다 중요하다고 믿는다.",
    category: "C",
  },
  {
    id: 17,
    text: "식사 예약이나 숙소 예약 등 세심한 배려가 필요한 일을 즐긴다.",
    category: "C",
  },
  {
    id: 18,
    text: "긴급한 연락이 왔을 때 즉각적으로 응답하는 습관이 있다.",
    category: "C",
  },
  {
    id: 19,
    text: "주변 정리가 지저분해도 업무 효율에 지장이 없다고 생각한다.",
    category: "C",
    rev: true,
  },
  {
    id: 20,
    text: "나는 회사의 비전과 나의 성장이 일치한다고 느낀다.",
    category: "C",
  },

  // --- [배우 매니징 역량: A (21-40)] ---
  {
    id: 21,
    text: "아티스트의 미세한 표정 변화만으로도 현재의 컨디션을 읽어낼 수 있다.",
    category: "A",
  },
  {
    id: 22,
    text: "대본이나 시나리오를 읽고 캐릭터의 매력 포인트를 분석하는 것을 좋아한다.",
    category: "A",
  },
  {
    id: 23,
    text: "배우의 정서적 불안정함은 시간이 해결해 줄 문제라고 생각한다.",
    category: "A",
    rev: true,
  },
  {
    id: 24,
    text: "촬영 현장에서 감독 및 스태프들과 원만한 커뮤니케이션을 유지할 자신이 있다.",
    category: "A",
  },
  {
    id: 25,
    text: "작품 모니터링 후 아티스트에게 객관적이고 건설적인 피드백을 줄 수 있다.",
    category: "A",
  },
  {
    id: 26,
    text: "배우의 이미지를 구축하기 위한 스타일링이나 의상 제안에 관심이 많다.",
    category: "A",
  },
  {
    id: 27,
    text: "장시간 이어지는 촬영 대기 시간을 견디는 것이 매우 힘들다.",
    category: "A",
    rev: true,
  },
  {
    id: 28,
    text: "아티스트가 연기에만 집중할 수 있도록 주변 환경을 미리 세팅한다.",
    category: "A",
  },
  {
    id: 29,
    text: "캐스팅 디렉터나 제작사 관계자와의 인적 네트워크 형성에 적극적이다.",
    category: "A",
  },
  {
    id: 30,
    text: "나는 아티스트의 사소한 고민이라도 진지하게 들어줄 준비가 되어 있다.",
    category: "A",
  },
  {
    id: 31,
    text: "작품의 성공을 위해서라면 아티스트의 사생활 제약은 당연하다고 생각한다.",
    category: "A",
    rev: true,
  },
  {
    id: 32,
    text: "현장에서 발생하는 배우의 건강 문제를 미리 예방하고 체크한다.",
    category: "A",
  },
  {
    id: 33,
    text: "배우가 가진 고유한 이미지를 브랜드화하는 과정에 흥미를 느낀다.",
    category: "A",
  },
  {
    id: 34,
    text: "다른 사람의 감정에 깊이 공감하는 편이라 금방 피로해진다.",
    category: "A",
    rev: true,
  },
  {
    id: 35,
    text: "언론 인터뷰나 공식 석상에서의 배우 멘트를 사전에 검토한다.",
    category: "A",
  },
  {
    id: 36,
    text: "현장에서 아티스트가 예민해질 때 함께 예민하게 반응하는 편이다.",
    category: "A",
    rev: true,
  },
  {
    id: 37,
    text: "계약 조건이나 정산 내역을 아티스트에게 투명하게 설명할 수 있다.",
    category: "A",
  },
  {
    id: 38,
    text: "배우의 차기작 선정을 위해 시장 반응을 데이터로 분석해보고 싶다.",
    category: "A",
  },
  {
    id: 39,
    text: "나는 아티스트의 그림자처럼 존재하며 묵묵히 지원하는 것이 체질에 맞는다.",
    category: "A",
  },
  {
    id: 40,
    text: "촬영장 식사 메뉴나 휴식 공간 확보는 매니저의 중요한 업무라고 믿는다.",
    category: "A",
  },

  // --- [가수 매니징 역량: S (41-60)] ---
  {
    id: 41,
    text: "음악 방송의 복잡한 동선과 리허설 시간을 정확히 숙지하고 통제할 수 있다.",
    category: "S",
  },
  {
    id: 42,
    text: "팬덤의 반응을 실시간으로 모니터링하고 이슈 발생 시 즉시 보고한다.",
    category: "S",
  },
  {
    id: 43,
    text: "공연이나 행사장 등 인파가 몰리는 곳에 있으면 무기력해진다.",
    category: "S",
    rev: true,
  },
  {
    id: 44,
    text: "아티스트의 무대 의상이나 소품 파손 시 현장에서 즉시 응급 처치가 가능하다.",
    category: "S",
  },
  {
    id: 45,
    text: "음원 차트 순위나 앨범 판매 데이터 추이를 분석하는 것을 즐긴다.",
    category: "S",
  },
  {
    id: 46,
    text: "팬들과의 소통 채널(SNS 등) 운영 시 가이드라인을 철저히 준수한다.",
    category: "S",
  },
  {
    id: 47,
    text: "불규칙한 수면 패턴과 야간 업무를 견디는 체력이 충분하다.",
    category: "S",
  },
  {
    id: 48,
    text: "아티스트의 퍼포먼스나 안무 연습 과정을 꼼꼼히 체크하고 기록한다.",
    category: "S",
  },
  {
    id: 49,
    text: "공항이나 공연장 이동 시 경호 동선 확보보다 팬 서비스가 우선이다.",
    category: "S",
    rev: true,
  },
  {
    id: 50,
    text: "나는 아티스트의 목 상태나 체중 관리 등 컨디션 케어에 엄격한 편이다.",
    category: "S",
  },
  {
    id: 51,
    text: "방송 작가나 PD에게 우리 아티스트를 어필하는 프로모션 능력이 있다.",
    category: "S",
  },
  {
    id: 52,
    text: "갑작스러운 스케줄 변경에도 당황하지 않고 관련 인원들에게 즉시 전파한다.",
    category: "S",
  },
  {
    id: 53,
    text: "공연 비하인드 영상이나 자체 콘텐츠 기획에 아이디어를 보탤 수 있다.",
    category: "S",
  },
  {
    id: 54,
    text: "나는 대중의 비난이나 악플에 멘탈이 쉽게 흔들리는 편이다.",
    category: "S",
    rev: true,
  },
  {
    id: 55,
    text: "해외 투어 시 필요한 비자나 서류 절차를 꼼꼼히 챙길 자신이 있다.",
    category: "S",
  },
  {
    id: 56,
    text: "팬클럽 운영진과의 소통은 가급적 피하는 것이 상책이라고 생각한다.",
    category: "S",
    rev: true,
  },
  {
    id: 57,
    text: "무대 위 아티스트의 안전을 위협하는 요소를 미리 찾아내 차단한다.",
    category: "S",
  },
  {
    id: 58,
    text: "나는 새로운 음악 장르나 안무 트렌드에 대해 항상 공부한다.",
    category: "S",
  },
  {
    id: 59,
    text: "긴박한 현장에서 아티스트가 평정심을 잃지 않도록 분위기를 주도한다.",
    category: "S",
  },
  {
    id: 60,
    text: "매니저는 아티스트의 비즈니스 파트너보다 '가족'에 더 가까워야 한다고 생각한다.",
    category: "S",
    rev: true,
  },
];
